export default {"src":"/_next/static/media/measurement-tape.3724263c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};